document.addEventListener("DOMContentLoaded", function () {
  const productIdsHandled = new Set();
  let lastRemovedItems = [];

  function isTargetItem(item) {
    const suffix = item?.properties?.template_suffix?.toLowerCase?.();
    return suffix === "bundled" || suffix === "build-your-own";
  }

  function getBundleQty(product) {
    const tag = product?.tags?.find((t) => t.startsWith("bundleqty_"));
    const qty = parseInt(tag?.split("_")[1], 10);
    return isNaN(qty) ? 3 : qty;
  }

  function showFeedbackMessage(productTitle, requiredQty) {
    const existing = document.querySelector(".bundle-feedback");
    if (existing) existing.remove();

    const div = document.createElement("div");
    div.className = "bundle-feedback";
    div.style = `
      position: fixed; top: 20px; right: 20px; background: #333; color: white;
      padding: 20px; border-radius: 8px; z-index: 99999999999; box-shadow: 0 2px 8px rgba(0,0,0,0.3);
      max-width: 480px; font-size: 14px; line-height: 1.4;
    `;

    div.innerHTML = `
      <button id="close-feedback" style="
        position: absolute; top: 8px; right: 10px; background: transparent;
        border: none; color: white; font-size: 18px; cursor: pointer;">&times;</button>
      <div style="margin-right: 24px; margin-top: 8px;">
        The bundle "<strong>${productTitle}</strong>" is incomplete or not in a valid quantity (must be in multiples of ${requiredQty}, e.g. ${requiredQty}, ${
      requiredQty * 2
    }, ${requiredQty * 3}, etc) and was removed.
        <div style="margin-top: 12px;">
          <button id="undo-bundle" style="
            background: #999; color: #333; border: none; padding: 6px 12px;
            border-radius: 4px; cursor: not-allowed;" disabled>Undo</button>
        </div>
      </div>
      <style>@media (max-width: 480px) {.bundle-feedback{left:20px;}}</style>
    `;
    document.body.appendChild(div);

    div
      .querySelector("#close-feedback")
      .addEventListener("click", () => div.remove());
    return div;
  }

  function calculateTotalQuantity(cart, productId) {
    return cart.items
      .filter((i) => i.product_id === productId && isTargetItem(i))
      .reduce((sum, i) => sum + i.quantity, 0);
  }

  function removeAllMatchingVariants(referenceItem, requiredQty = 3) {
    const productId = referenceItem.product_id;
    if (productIdsHandled.has(productId)) return;
    productIdsHandled.add(productId);

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const updates = {};
        const removed = [
          {
            variant_id: referenceItem.variant_id,
            quantity: referenceItem.quantity,
            properties: referenceItem.properties || {},
          },
        ];
        let productTitle = referenceItem.product_title || referenceItem.title;

        cart.items.forEach((item) => {
          if (item.product_id === productId && isTargetItem(item)) {
            updates[item.key] = 0;
            if (item.variant_id !== referenceItem.variant_id) {
              removed.push({
                variant_id: item.variant_id,
                quantity: item.quantity,
                properties: item.properties || {},
              });
            }
            if (!productTitle && item.product_title)
              productTitle = item.product_title;
          }
        });

        if (Object.keys(updates).length === 0) return;

        let feedbackDiv = null;
        let undoButton = null;
        if (window.location.pathname !== "/cart") {
          feedbackDiv = showFeedbackMessage(productTitle, requiredQty);
          undoButton = feedbackDiv.querySelector("#undo-bundle");
        }
        // const feedbackDiv = showFeedbackMessage(productTitle, requiredQty);
        // const undoButton = feedbackDiv.querySelector("#undo-bundle");

        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        }).then(() => {
          if (undoButton) {
            lastRemovedItems = removed;
            undoButton.disabled = false;
            undoButton.style.cursor = "pointer";
            undoButton.style.background = "#7b9a62";
            undoButton.style.color = "#ffffff";

            undoButton.addEventListener("click", function () {
              const sanitizedItems = lastRemovedItems
                .filter((item) => item.variant_id && item.quantity)
                .map((item) => ({
                  id: item.variant_id,
                  quantity: item.quantity,
                  ...(item.properties && Object.keys(item.properties).length > 0
                    ? { properties: item.properties }
                    : {}),
                }));

              fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ items: sanitizedItems }),
              })
                .then((res) => {
                  if (!res.ok) {
                    return res.text().then((text) => {
                      throw new Error(text);
                    });
                  }
                  return res.json();
                })
                .then(() => {
                  feedbackDiv.remove();
                  // location.reload();

                  if (window.location.pathname === "/cart") {
                    location.reload();
                  } else if (window.Rebuy?.SmartCart?.render) {
                    Rebuy.SmartCart.render();
                  }
                })
                .catch((err) => {
                  alert("Failed to re-add bundle: " + err.message);
                  console.error("Cart add error:", err);
                });
            });

            setTimeout(() => feedbackDiv.remove(), 12000);
          }
          // Reload if on the cart page
          if (window.location.pathname === "/cart") {
            location.reload();
          }
        });
      });

    setTimeout(() => productIdsHandled.delete(productId), 5000);
  }

  function validateAndRemoveIfNeeded(referenceItem, product) {
    const requiredQty = getBundleQty(product);

    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const totalQty = calculateTotalQuantity(cart, referenceItem.product_id);
        if (totalQty < requiredQty || totalQty % requiredQty !== 0) {
          removeAllMatchingVariants(referenceItem, requiredQty);
        }
      });
  }

  // REBUY EVENTS
  [
    "rebuy:smartcart.line-item-decrease",
    "rebuy:smartcart.line-item-increase",
    "rebuy:smartcart.line-item-removed",
  ].forEach((eventName) => {
    document.addEventListener(eventName, function (event) {
      const item = event.detail.item;
      if (!item || !isTargetItem(item)) return;
      if (productIdsHandled.has(item.product_id)) return;

      fetch(`/products/${item.handle}.js`)
        .then((res) => res.json())
        .then((product) => {
          setTimeout(() => {
            validateAndRemoveIfNeeded(item, product);
          }, 250);
        });
    });
  });

  // CART PAGE HANDLING
  async function getItemFromDOM(row) {
    const quantityInput = row.querySelector("input.quantity__input");
    const variantId = quantityInput?.dataset.quantityVariantId;
    const quantity = parseInt(quantityInput?.value, 10);
    const productHandle = row
      .querySelector("a.cart-item__name")
      ?.getAttribute("href")
      ?.split("/products/")[1]
      ?.split("?")[0];

    if (!variantId || !productHandle) return null;

    // Optional: Extract any line item properties from the DOM if needed
    const properties = {};
    const dl = row.querySelector("dl");
    if (dl) {
      const dtElements = dl.querySelectorAll("dt");
      const ddElements = dl.querySelectorAll("dd");
      for (let i = 0; i < dtElements.length; i++) {
        const key = dtElements[i].textContent.trim().toLowerCase();
        const value = ddElements[i].textContent.trim();
        if (key && value) {
          properties[key] = value;
        }
      }
    }

    // Wait for the product fetch
    const product_return = await fetch(`/products/${productHandle}.js`).then(
      (res) => res.json()
    );
    return {
      variant_id: parseInt(variantId, 10),
      handle: productHandle,
      product_id: product_return.id,
      quantity,
      properties, // fill as needed
    };
  }

  function handleCartPageQuantityEvents() {
    document
      .querySelectorAll(".quantity__button, .cart-item__quantity input")
      .forEach((buttonOrInput) => {
        buttonOrInput.addEventListener("change", onCartQuantityChange);
        buttonOrInput.addEventListener("click", () =>
          setTimeout(onCartQuantityChange, 250)
        );
      });

    document.querySelectorAll("cart-remove-button a").forEach((link) => {
      link.addEventListener("click", async (e) => {
        const row = e.target.closest("tr.cart-item");
        const item = await getItemFromDOM(row); // <-- await here

        if (item) {
          e.preventDefault(); // Prevent default remove
          const product = await fetch(`/products/${item.handle}.js`).then(
            (res) => res.json()
          );
          validateAndRemoveIfNeeded(item, product);
        }
      });
    });
  }

  async function onCartQuantityChange() {
    const rows = document.querySelectorAll("tr.cart-item");

    for (const row of rows) {
      const item = await getItemFromDOM(row); // this should now support awaiting if needed

      if (item) {
        try {
          const res = await fetch(`/products/${item.handle}.js`);
          const product = await res.json();
          await validateAndRemoveIfNeeded(item, product);
        } catch (error) {
          console.error("Error fetching product or validating:", error);
        }
      }
    }
  }

  handleCartPageQuantityEvents();
});
